import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { usePrivate } from '../context/PrivateInfoContext';

function BoletosDialog({close}){
    const { tableNegociacao, negociadasColumns } = usePrivate()

    return(
    <div className='boletosDialog'>
        <Dialog
        visible
        className='boletosDialog'
        onHide={()=>close()}
        style={{
            minHeigth:'30vw', 
            minWidth: '20vw', 
            textAlign: 'center',
            borderRadius: '30px',
            padding: '10px',
            fontFamily:'Branding-Bold, serif'
        }}
        draggable={false}
        header="Negociações Anteriores"
        >
           <DataTable
            value={tableNegociacao}
            breakpoint='860px'
            
            >
            {negociadasColumns.map((column, index) => (
                <Column
                key={index}
                header={column.header}
                field={column.field}
                // headerStyle={column.header}
                body={column.body}
                style={column.style}
                />
                ))}
            </DataTable>
        </Dialog>
    </div>
    )
}

export default BoletosDialog